import React from 'react'
import PropTypes from 'prop-types'

const Item = ({ description, children, className, classFont }) => (
  <div className={className}>
    <div
      className={`${classFont} col-6 txt-title-3 txt-font-body txt-left justify-content-center align-self-center`}
    >
      {description}
    </div>
    <div
      className={`${classFont} col-6 txt-title-3 txt-subtitle txt-font-body txt-right justify-content-center align-self-center`}
    >
      {children}
    </div>
  </div>
)

Item.propTypes = {
  description: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  classFont: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired
}

export default Item



// WEBPACK FOOTER //
// ./src/features/SummaryOrder/Item.js